let designs = [];
$(document).ready(function(){
    if( !!__is_bundles ){
      let designs = [];
        bundlesInitial();
        $(".step2").find(".card").on("click",function(){
          $(this).toggleClass("selected");
        });
        
        $(document).on('submit', 'form[action="/cart/add"]', function (e) {
            // collect all design names into a comma string
            
        });
    }
});

async function ATCBundle(){
    //const variant = meta.selected_variant || meta.product.variants[0];

    // const designs = collectDesigns();

    if( designs.length===0 ){
        Swal.fire('Please select at least one design');
        return false;
    }

    return true;
    /*
    if (!response.ok) {
        const err = await response.text();
        Swal.fire('Step 2 add falied');
        console.error('Step 2 add failed:', err);
        return false;
    }
    
    return true;
    */
}

function bundlePrice(){
    let qty = $("input[name='quantity']").val();
  
    let options = $("input[name='bundle']");
let checkedIndex = options.index($("input[name='bundle']:checked"));
    const variant = meta.selected_variant || meta.product.variants[checkedIndex];
    const unitPrice = variant.price; // in cents
    console.log("meta",meta);
    console.log("variant",variant);
    console.log("varaint price", variant.price);
    // if( qty>=3 ){
    //     return ((unitPrice-300) * qty) / 100;
    // }else
     return (unitPrice * qty) / 100;
}

function bundleComparedAtPrice(){
    let qty = $("input[name='quantity']").val();
    
    let options = $("input[name='bundle']");
let checkedIndex = options.index($("input[name='bundle']:checked"));
    const variant = meta.selected_variant || meta.product.variants[checkedIndex];
    const unitPrice = variant.price; // in cents
    return (unitPrice * qty) / 100;
}

function bundlesInitial(){
  
    $(".pdp_bundles > .bundle_container").on("click",function(){
        //console.log( $(this).data("value") );
        const clickedIndex = $(".pdp_bundles > .bundle_container").index(this);
       
        $('.cs_options').eq(clickedIndex).click();
   
       
        let qty = $(this).data("value");
        // $("input[name='quantity']").val(qty);
        // console.log("value of qty",$("input[name='quantity']"));
        // console.log("value of qty",$("input[name='quantity']").val());
        $(".pdp_bundles").find(".bundle").removeClass("selected");
        $(this).find(".bundle").addClass("selected");
        __bundle = $(this).data("name");

        if(designs.length > 0) {
          recalcDesigns();
        }

        const variant = meta.selected_variant || meta.product.variants[0];
        const unitPrice = variant.price; // in cents
        

        
        // Convert to dollars
        const totalPrice     = (unitPrice * qty) / 100;
        const totalCompareAt = (__compare_at_price * qty) / 100;

        // How many installments (Shopify usually shows 4 for 50–149.99)
        const installmentsCount = 4;

        // Calculate 4 installments
        const installment = totalPrice / installmentsCount;

        // Format nicely (USD)
        const formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD'
        });

        // // update sale/actual price
        // $(".product__info-container").find(".price-item.price-item--regular").text(
        //     formatter.format(totalPrice) + " " + __currency
        // );

        // // update compare at (only if > 0)
        // if (totalCompareAt > 0) {
        //     $(".product__info-container").find(".price-item.price-item--sale.price-item--last").text(
        //         formatter.format(totalCompareAt) + " " + __currency
        //     );
        // }

        // now update the Shop Pay terms
        const termsEl = document.querySelector('shopify-payment-terms');
        if (termsEl) {
            const shadow = termsEl.shadowRoot;
            if (shadow) {
                const content = shadow.querySelector('#shopify-installments-content');
                const bold    = shadow.querySelector('.font-bold');

                // formatted installment
                const perTermStr = formatter.format(installment);

                if (bold) {
                    bold.textContent = perTermStr;
                }

                if (content) {
                    // safer than childNodes[0]
                    const firstNode = content.firstChild;
                    if (firstNode && firstNode.nodeType === Node.TEXT_NODE) {
                        firstNode.textContent = `Pay in ${installmentsCount} interest-free installments of `;
                    } else {
                        // fallback, rebuild whole text (then append bold again)
                        content.textContent = `Pay in ${installmentsCount} interest-free installments of `;
                        content.appendChild(bold);
                    }
                }
            }
        }

        window.dispatchEvent( new CustomEvent("__bundle_changed", {detail: null}) );
    });
}
function recalcDesigns() {
  if( __bundle==="basic" ){
    free_slot = {base: 1, free: 1};
  }
  else if( __bundle==="standard" ){
    free_slot = {base: 2, free: 2};
  }
  else if( __bundle==="premium" ){
    free_slot = {base: 3, free: 3};
  }
  const totalSlots = free_slot.base + free_slot.free;
  designs.forEach((item, idx) => {
    item.extra = idx > (totalSlots - 1);
    item.indexp = idx;
  });
}


async function addToCartAndShowDrawer(formData) {
  // 1. add to cart
  const resp = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify(formData)
  });

  if (!resp.ok) {
    console.warn('Add to cart failed');
    return;
  }

}

async function addToCartWithDrawer(variantId, qty = 1) {
  // 1) get the drawer element
  const drawer = document.querySelector('cart-drawer');

  // 2) figure out which sections the drawer wants to re-render
  const sections = drawer
    ? drawer.getSectionsToRender().map((s) => s.id)
    : ['cart-drawer', 'cart-icon-bubble'];

  // 3) build the same JSON Dawn sends
  const body = JSON.stringify({
    id: variantId,
    quantity: qty,
    sections: sections,
    sections_url: window.location.pathname,
  });

  // 4) pick the right URL (what Dawn uses)
  const url =
    (window.routes && window.routes.cart_add_url) ||
    (window.Shopify && window.Shopify.routes && window.Shopify.routes.root + 'cart/add') ||
    '/cart/add';

  const res = await fetch(url, {
    method: 'POST',
    headers: {
      // same as Dawn’s fetchConfig('javascript') result
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    },
    body,
  });

  const data = await res.json();

  // if Shopify returned an error payload, handle it
  if (data.status) {
    console.warn('cart error:', data);
    return;
  }

  // 5) now let the drawer update itself (this is exactly what your snippet does)
  if (drawer && typeof drawer.renderContents === 'function') {
    drawer.renderContents(data);
  } else {
    console.warn('cart-drawer not found or renderContents missing');
  }
  initRecommendations();
}